export async function getDealersRegistryReport(): Promise<{
  fileHash: string;
}> {
  const response = await fetch(`/internal-api/dealer/registry-report`, {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  return await response.json();
}
